import React from 'react'
import { ReactComponent as SortDefaultIcon } from '../../assets/icons/sort-default.svg'
import { ReactComponent as SortAscIcon } from '../../assets/icons/sort-asc.svg'
import { ReactComponent as SortDescIcon } from '../../assets/icons/sort-desc.svg'

const SortIcon = ({ sortOrder }) => {
    if (sortOrder === 'asc') {
        return <SortAscIcon />
    } else if (sortOrder === 'desc') {
        return <SortDescIcon />
    } else {
        return <SortDefaultIcon />
    }
}

export default SortIcon
